// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"5ffa2676","415":"1ee31102","453":"c3d08517","701":"f37b4ac2","904":"44a6649b"}[chunkId] + ".chunk.js";
};